import axios, { AxiosInstance } from "axios";
import { Variable, envVariable } from "@/common/constants/envVariable";
import { RefreshTokenInterceptor } from "./interceptors/refreshTokenInterceptor";
import { Controller } from "./controller";

export class Client {
	private static clientInstace: Client;
	private readonly axiosInstance: AxiosInstance;
	private readonly apacAxiosInstance: AxiosInstance;

	public static get instance(): Client {
		if (!Client.clientInstace) {
			Client.clientInstace = new Client();
		}

		return Client.clientInstace;
	}

	private constructor() {
		this.axiosInstance = new RefreshTokenInterceptor().setupTo(
			axios.create({
				baseURL: envVariable(Variable.GatewayApiUrl),
				headers: { "Content-Type": "application/json" },
			})
		);

		this.apacAxiosInstance = new RefreshTokenInterceptor().setupTo(
			axios.create({
				baseURL: envVariable(Variable.GatewayApacApiUrl),
				headers: { "Content-Type": "application/json" },
			})
		);
	}

	public post<T>(url: string,
		body: any | undefined = undefined,
		headers: { [key: string]: any } | undefined = undefined,
		signal?: AbortSignal): Promise<T> {
		return this.axiosInstance.post(url, body, { headers, signal });
	}

	public postFormData<T>(url: string, formData: FormData): Promise<T> {
		return this.axiosInstance.post(url, formData, {
			headers: { "Content-Type": "multipart/form-data" }
		});
	}

	public get<T>(
		url: string,
		params: { [key: string]: any } | undefined = undefined,
		signal?: AbortSignal,
		headers: { [key: string]: any } | undefined = undefined
	): Promise<T> {
		return this.axiosInstance.get(url, {
			params,
			headers,
			signal
		});
	}

	public getApac<T>(
		url: string,
		params: { [key: string]: any } | undefined = undefined
	): Promise<T> {
		return this.apacAxiosInstance.get(url, { params: params });
	}

	public patch<T>(url: string, body: any | undefined = undefined): Promise<T> {
		return this.axiosInstance.patch(url, body);
	}

	public put<T>(url: string, body: any | undefined = undefined): Promise<T> {
		return this.axiosInstance.put(url, body);
	}

	public delete<T>(url: string, body: any | undefined = undefined): Promise<T> {
		return this.axiosInstance.delete(url, body);
	}
}

export const mapUrl = (
	controller: Controller,
	...subdirectories: string[]
): string => {
	return [controller, ...subdirectories].filter((x) => !!x).join("/");
};
